"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var workflow_1 = require("../../../../../../reducers/slices/workflow/workflow");
var reactflow_1 = require("reactflow");
var doshx_controls_web_1 = require("doshx_controls_web");
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var constants_1 = require("../constants");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var doshx_controls_web_2 = require("doshx_controls_web");
var IWorkflow_1 = require("../../../../../../interfaces/IWorkflow");
var react_2 = require("@nextui-org/react");
var react_3 = require("@iconify/react");
var node_pin_1 = __importDefault(require("./node_pin"));
var CustomNode = function (props) {
    var dispatch = (0, react_redux_1.useDispatch)();
    var id = props.id, type = props.type, category = props.category, data = props.data, draggable = props.draggable, children = props.children, configurationComponent = props.configurationComponent, colors = props.colors, infoPopOver = props.infoPopOver;
    var className = props.className, prop_icon = props.icon;
    var _a = (0, react_1.useState)(prop_icon), icon = _a[0], setIcon = _a[1];
    var _b = (0, react_1.useState)(false), configurable = _b[0], setConfigurable = _b[1];
    var _c = (0, react_1.useState)(false), isOpen = _c[0], setIsOpen = _c[1];
    var _d = (0, react_1.useState)(false), showConfiguration = _d[0], setShowConfiguration = _d[1];
    var _e = (0, react_1.useState)(false), hasErrors = _e[0], setHasErrors = _e[1];
    var isGraphNode = Boolean(id);
    var getRelevantPins = function () {
        var inputPins = [];
        var outputPins = [];
        if (category !== "event") {
            var execInId = "".concat(id || type, "_exec_out");
            inputPins.push({
                id: execInId,
                name: "exec",
                direction: IWorkflow_1.PinDirection.INPUT,
                type: IWorkflow_1.PinType.EXECUTION,
                metadata: { description: "Execution input" },
            });
        }
        var execOutId = "".concat(id || type, "_exec_out");
        outputPins.push({
            id: execOutId,
            name: "exec",
            direction: IWorkflow_1.PinDirection.OUTPUT,
            type: IWorkflow_1.PinType.EXECUTION,
            metadata: { description: "Execution output" },
        });
        {
            /* Currently disable data pins for MVP */
        }
        // const pinConfig = NODE_PIN_CONFIGS[type] || { inputs: [], outputs: [] };
        var pinConfig = { inputs: [], outputs: [] };
        var dataInputPins = pinConfig.inputs.map(function (pinName) {
            var pinId = "".concat(id || type, "_input_").concat(pinName);
            return {
                id: pinId,
                name: pinName,
                direction: IWorkflow_1.PinDirection.INPUT,
                type: IWorkflow_1.PinType.DATA,
                required: pinName === "data",
                metadata: { description: "".concat(pinName, " input") },
                dataType: pinName === "data" ? IWorkflow_1.VariableType.OBJECT : IWorkflow_1.VariableType.UNKNOWN,
            };
        });
        var dataOutputPins = pinConfig.outputs.map(function (pinName) {
            var pinId = "".concat(id || type, "_output_").concat(pinName);
            return {
                id: pinId,
                name: pinName,
                direction: IWorkflow_1.PinDirection.OUTPUT,
                type: IWorkflow_1.PinType.DATA,
                metadata: { description: "".concat(pinName, " output") },
                dataType: pinName === "data" ? IWorkflow_1.VariableType.OBJECT : IWorkflow_1.VariableType.UNKNOWN,
            };
        });
        inputPins.push.apply(inputPins, dataInputPins);
        outputPins.push.apply(outputPins, dataOutputPins);
        return {
            inputPins: inputPins,
            outputPins: outputPins,
        };
    };
    (0, react_1.useEffect)(function () {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (isGraphNode) {
            var nodeConfig = (_a = constants_1.nodeConfigurations[category]) === null || _a === void 0 ? void 0 : _a.find(function (nodeConfig) { return nodeConfig.type === type && nodeConfig.data.name === data.name; });
            if (nodeConfig) {
                setConfigurable((_b = nodeConfig.data) === null || _b === void 0 ? void 0 : _b.configurable);
                if (!icon && ((_c = nodeConfig.data) === null || _c === void 0 ? void 0 : _c.icon)) {
                    setIcon((_d = nodeConfig.data) === null || _d === void 0 ? void 0 : _d.icon);
                }
                if (!data.schema && ((_e = nodeConfig.data) === null || _e === void 0 ? void 0 : _e.schema)) {
                    dispatch((0, workflow_1.setNode)({ id: id, data: __assign(__assign({}, data), { schema: (_f = nodeConfig.data) === null || _f === void 0 ? void 0 : _f.schema }), edit: false }));
                }
            }
            if (!((_g = data.inputPins) === null || _g === void 0 ? void 0 : _g.length) && !((_h = data.outputPins) === null || _h === void 0 ? void 0 : _h.length)) {
                var pins = getRelevantPins();
                if (pins) {
                    dispatch((0, workflow_1.setNode)({ id: id, data: __assign(__assign({}, data), { inputPins: pins.inputPins, outputPins: pins.outputPins }), edit: false }));
                }
                else {
                    console.log("Node ".concat(id, " has no pins. Likely missing configuration"));
                }
            }
        }
    }, [id, type, category, data, dispatch, isGraphNode, icon]);
    (0, react_1.useEffect)(function () {
        if (!isGraphNode)
            return;
        if (data.errors && Object.keys(data.errors).length > 0) {
            setHasErrors(true);
            setShowConfiguration(true);
        }
        else if (hasErrors) {
            setHasErrors(false);
        }
    }, [data.errors, hasErrors, isGraphNode]);
    var onDragStart = null;
    if (draggable) {
        className += " cursor-move";
        onDragStart = function (event) {
            event.dataTransfer.setData("application/reactflow", type);
            event.dataTransfer.effectAllowed = "move";
            dispatch((0, workflow_1.setNewNode)({ type: type, data: data }));
        };
    }
    var borderColor = "border-borders";
    if (props.selected) {
        borderColor = "border-tertiary";
    }
    else if (hasErrors) {
        borderColor = "border-error";
    }
    var InfoPopOver = function () { return ((0, jsx_runtime_1.jsxs)(react_2.Popover, __assign({ placement: "bottom", isOpen: isOpen, onOpenChange: setIsOpen }, { children: [(0, jsx_runtime_1.jsx)(react_2.PopoverTrigger, { children: (0, jsx_runtime_1.jsx)(react_2.Button, __assign({ isIconOnly: true, size: "sm", className: "text-labelText hover:text-tertiary bg-white", onMouseEnter: function () { return setIsOpen(true); }, onMouseLeave: function () { return setIsOpen(false); } }, { children: (0, jsx_runtime_1.jsx)(react_3.Icon, { icon: "solar:info-circle-linear", className: "text-black", style: { marginTop: "-5px", marginLeft: "-5px" } }) })) }), (0, jsx_runtime_1.jsx)(react_2.PopoverContent, __assign({ onMouseEnter: function () { return setIsOpen(true); }, onMouseLeave: function () { return setIsOpen(false); } }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col max-w-md rounded-sm" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "font-bold bg-blue-100 text-lg p-2 shadow" }, { children: infoPopOver === null || infoPopOver === void 0 ? void 0 : infoPopOver.summary })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "p-2" }, { children: infoPopOver === null || infoPopOver === void 0 ? void 0 : infoPopOver.content }))] })) }))] }))); };
    var renderConfigurationButton = function () { return ((0, jsx_runtime_1.jsx)(react_2.Button, __assign({ isIconOnly: true, variant: showConfiguration ? "solid" : "light", size: "sm", radius: "full", onPress: function () { return setShowConfiguration(!showConfiguration); }, className: showConfiguration ? "bg-blue-100 hover:bg-blue-200" : "bg-transparent hover:bg-blue-100" }, { children: showConfiguration ? ((0, jsx_runtime_1.jsx)(react_3.Icon, { icon: "solar:alt-arrow-up-outline", className: "".concat((colors === null || colors === void 0 ? void 0 : colors.iconColor) || "text-tertiary", " w-5 h-5") })) : ((0, jsx_runtime_1.jsx)(react_3.Icon, { icon: "solar:alt-arrow-down-outline", className: "".concat((colors === null || colors === void 0 ? void 0 : colors.iconColor) || "text-tertiary", " w-5 h-5") })) }))); };
    var RenderHeader = function () {
        var _a;
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-row items-center gap-4" }, { children: [(0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: icon !== null && icon !== void 0 ? icon : pro_light_svg_icons_1.faCircle, size: "xl", className: "".concat((_a = colors === null || colors === void 0 ? void 0 : colors.iconColor) !== null && _a !== void 0 ? _a : "text-tertiary", " w-5") }), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex-1 flex-col" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-row gap-2" }, { children: [(0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: data === null || data === void 0 ? void 0 : data.name, textColor: "text-labelText", maxLines: "one" }), infoPopOver && showConfiguration && (0, jsx_runtime_1.jsx)(InfoPopOver, {})] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "flex flex-row items-center justify-between gap-2" }, { children: (0, jsx_runtime_1.jsx)(doshx_controls_web_1.LabelControl, { label: doshx_controls_web_2.Utilities.titleCase(category), maxLines: "one", size: "xsmall", textColor: "text-labelText" }) }))] }))] })));
    };
    var renderAllPins = function () {
        var _a, _b;
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex justify-between gap-2 -mx-5 -mt-4" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "flex flex-col gap-2 items-start min-w-0 flex-1" }, { children: (_a = data.inputPins) === null || _a === void 0 ? void 0 : _a.map(function (pin) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "w-full" }, { children: (0, jsx_runtime_1.jsx)(node_pin_1.default, { pin: pin, position: reactflow_1.Position.Left, showLabel: true, isConnected: pin.isConnected }) }), pin.id)); }) })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "flex flex-col gap-2 items-end min-w-0 flex-1" }, { children: (_b = data.outputPins) === null || _b === void 0 ? void 0 : _b.map(function (pin) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "w-full" }, { children: (0, jsx_runtime_1.jsx)(node_pin_1.default, { pin: pin, position: reactflow_1.Position.Right, showLabel: true, isConnected: pin.isConnected }) }), pin.id)); }) }))] })));
    };
    var hasDataPins = (0, react_1.useCallback)(function (data) {
        var _a, _b;
        return ((_a = data.inputPins) === null || _a === void 0 ? void 0 : _a.some(function (pin) { return pin.type !== IWorkflow_1.PinType.EXECUTION; })) || ((_b = data.outputPins) === null || _b === void 0 ? void 0 : _b.some(function (pin) { return pin.type !== IWorkflow_1.PinType.EXECUTION; }));
    }, [data.inputPins, data.outputPins]);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "flex flex-col min-w-[220px] max-w-md px-4 py-2 shadow hover:shadow-md rounded-md bg-white border-2 ".concat(borderColor, " ").concat(className, " relative"), draggable: draggable, onDragStart: onDragStart }, { children: [(0, jsx_runtime_1.jsx)(RenderHeader, {}), isGraphNode && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_2.Divider, { className: "bg-borders my-2 " }), renderAllPins(), configurationComponent && hasDataPins(data) && (0, jsx_runtime_1.jsx)(react_2.Divider, { className: "bg-borders my-2 " }), configurationComponent && (0, jsx_runtime_1.jsx)("div", __assign({ className: "flex flex-col" }, { children: configurationComponent(data) })), children] }))] })));
};
exports.default = (0, react_1.memo)(CustomNode);
